import { render, staticRenderFns } from "./CustomerHeading.vue?vue&type=template&id=695ccb50&scoped=true&"
import script from "./CustomerHeading.vue?vue&type=script&lang=js&"
export * from "./CustomerHeading.vue?vue&type=script&lang=js&"
import style0 from "./CustomerHeading.vue?vue&type=style&index=0&id=695ccb50&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695ccb50",
  null
  
)

export default component.exports